import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useRouteMatch } from 'react-router-dom';

import { getPuzzleNumber } from '../utils/helpers';

const ARCHIVE_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

/**
 * Which puzzle the page is showing, for chrome that renders *outside*
 * TodaysCountryProvider. That provider is mounted per route, and
 * useTodaysCountry() throws without it, so the header and footer — which live
 * above the router in App — cannot read the day from context.
 *
 * The result mirrors what the routes themselves do: ArchiveDateRoute takes the
 * date from the URL, GameRoute uses today.
 */
export function usePuzzleDay() {
  const archiveMatch = useRouteMatch<{ date: string }>('/archive/:date');
  const archiveDate = archiveMatch?.params.date;

  return useMemo(() => {
    const isArchive = Boolean(
      archiveDate && ARCHIVE_DATE_PATTERN.test(archiveDate),
    );
    const dayString = isArchive
      ? (archiveDate as string)
      : dayjs().format('YYYY-MM-DD');

    return { dayString, puzzleNumber: getPuzzleNumber(dayString), isArchive };
  }, [archiveDate]);
}
